export default __webpack_public_path__ + "static/media/cfi.a8c7de20.png";